import dbData from '../data/db.json';

export const localContentService = {
  // Get content by section name
  getContentBySection: async (sectionName) => {
    try {
      // Map section names to db.json keys
      const sectionMap = {
        'service': 'themeOneServiceSection',
        'feature': 'themeOneFeatureSection',
        'discover': 'themeOneDiscoverSection',
        'work': 'themeOneWorkSection',
        'pricing': 'themeOnePricingSection',
        'faq': 'themeOneFaqSection',
        'team': 'themeOneTeamSection',
        'contact': 'themeOneContactSection',
        'footer': 'themeOneFooterSection',
        'blog': 'themeOneBlogSection'
      };

      const dbKey = sectionMap[sectionName];
      if (!dbKey || !dbData[dbKey]) {
        return {
          success: false,
          error: `Content not found for section: ${sectionName}`,
          data: []
        };
      }

      // Simulate async behavior
      await new Promise(resolve => setTimeout(resolve, 100));

      return {
        success: true,
        data: [{
          id: 1,
          section_name: sectionName,
          content_data: dbData[dbKey]
        }]
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  },

  // Get all content sections
  getAllSections: async () => {
    try {
      const sections = Object.keys(dbData).map(key => ({
        section_name: key,
        section_title: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
        section_description: `Content for ${key}`
      }));

      // Simulate async behavior
      await new Promise(resolve => setTimeout(resolve, 100));

      return {
        success: true,
        data: sections
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        data: []
      };
    }
  }
}; 